import { useCallback, useContext } from "react";
// types
import {
    CheckoutActionTypes,
    getBridgeSdk,
    CheckoutContext,
    GlobalHeaderState,
    SwgyHeaderKeysList,
    ConfigContext,
    NEWRELIC_TABLES,
    recordNREvent,
} from "@swiggy-private/checkout-core";
import { NavigationTypes } from "@swiggy-private/native-bridge";
import { WebviewRefreshOrderIdMismatchAlertPayload } from "@swiggy-private/checkout-core";
import { OrderIdMismatchAlertPayload } from "@swiggy-private/payment-core";
// constants
import { ORDERID_MISMATCH_ALERT_DATA } from "@payment-client/constants/WebviewRefresh";
import { isAppPlatform } from "@swiggy-private/core-ui";

const IM_CART_DEEPLINK = "swiggy://stores/instamart/cart?source=duplicate_order_popup";

export const useLaunchWebviewRefreshOrderIdMismatchAlert = () => {
    const { setCheckoutState } = useContext(CheckoutContext);
    const { enableConfirmOrderDifferentialOrderIdAlert } = useContext(ConfigContext);

    const launchHalfCardForWebviewRefreshOrderIsMismatch = useCallback(() => {
        const platform = GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform);
        const isApp = isAppPlatform(platform);
        const isConfigEnabled = enableConfirmOrderDifferentialOrderIdAlert?.unwrapOr(false);
        if (!isApp || !isConfigEnabled) {
            return;
        }
        try {
            recordNREvent({
                eventType: NEWRELIC_TABLES.WEBVIEW_REFRESH_INFO,
                name: "launchOrderIdCollisionHalfCardCalled",
                platform,
                isApp: String(isApp),
                enabled: String(isConfigEnabled),
            });
        } catch (_) {
            // no-op
        }

        const payload = {
            alertData: {
                title: ORDERID_MISMATCH_ALERT_DATA.title,
                cta: {
                    text: ORDERID_MISMATCH_ALERT_DATA.ctaText,
                    onClick: () => {
                        try {
                            recordNREvent({
                                eventType: NEWRELIC_TABLES.WEBVIEW_REFRESH_INFO,
                                name: "orderIdCollisionHalfCardCTAClicked",
                                deeplink: IM_CART_DEEPLINK,
                            });
                        } catch (_) {
                            // no-op
                        }
                        getBridgeSdk()
                            .navigateToScreen({
                                type: NavigationTypes.DEEPLINK,
                                link: IM_CART_DEEPLINK,
                                params: {
                                    shouldCloseWebview: true,
                                },
                            })
                            .catch(() => {
                                // no-op
                            });
                    },
                },
            } as OrderIdMismatchAlertPayload,
        } as WebviewRefreshOrderIdMismatchAlertPayload;

        setCheckoutState({
            type: CheckoutActionTypes.WEBVIEW_REFRESH_ORDER_ID_MISMATCH_ALERT,
            payload,
        });
    }, [enableConfirmOrderDifferentialOrderIdAlert, setCheckoutState]);

    return {
        launchHalfCardForWebviewRefreshOrderIsMismatch,
    };
};
